export default __webpack_public_path__ + "static/media/dermatologista.553051f4.png";